/**
 * PlatformGuideUI
 *
 * Chat over platform documentation (corpus = 'platform_docs').
 * Thin wrapper around ChatToolUI.
 */
import React from 'react';
import { ChatToolUI } from './ChatToolUI';
import type { Tool } from '@/types/database';

interface Props {
  tool: Tool;
}

export const PlatformGuideUI: React.FC<Props> = ({ tool }) => (
  <ChatToolUI
    tool={tool}
    showModelPicker={false}
    placeholder="Ask how to use AgentForge…"
  />
);
